import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import api from '@services/api'
import { AxiosError } from 'axios'
import type { AIFashionModelsData } from './types'

export type { AIFashionModelsData }

export const setAIFashionModels = createAction<AIFashionModelsData>('aiFashionModels/setAIFashionModels')

export const getAIFashionModels = createAsyncThunk<void, never, { rejectValue: Record<string, string[]> }>(
  'aiFashionModels/getAIFashionModels',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const data = await api.getAIFashionModels()
      if (data.data.length > 0) dispatch(setAIFashionModels(data))
    } catch (err) {
      return rejectWithValue(((err as AxiosError).response?.data as any)?.error.data || null)
    }
  }
)
